import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { RECOMMENDED_MARGIN_LABEL, REQUIRED_MARGIN_LABEL } from 'shared-modules/constants';
import { InfoTooltip } from '../InfoTooltip';
import { MarginText } from '../Texts';
import styles from './marginInfo.module.scss';

export const MarginInfo = memo(({ className, requiredMargin, recommendedMargin }) => (
  <div className={classNames(styles.container, className)}>
    {Boolean(requiredMargin?.get) && (
      <div className={styles.row}>
        <div className={styles.labelContainer}>
          {requiredMargin.label || REQUIRED_MARGIN_LABEL}
          {requiredMargin.tooltip && <InfoTooltip message={requiredMargin.tooltip} />}
        </div>
        <MarginText className={styles.margin} value={requiredMargin.get} />
      </div>
    )}
    {Boolean(recommendedMargin?.get) && (
      <div className={styles.row}>
        <div className={styles.labelContainer}>
          {recommendedMargin.label ?? RECOMMENDED_MARGIN_LABEL}
          {recommendedMargin.tooltip && <InfoTooltip message={recommendedMargin.tooltip} />}
        </div>
        <MarginText className={styles.margin} value={recommendedMargin.get} />
      </div>
    )}
  </div>
));

MarginInfo.propTypes = {
  className: PropTypes.string,
  effectiveMargin: PropTypes.shape({
    get: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }),
  requiredMargin: PropTypes.shape({
    get: PropTypes.number,
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }),
  recommendedMargin: PropTypes.shape({
    get: PropTypes.number,
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }),
};

MarginInfo.defaultProps = {
  className: undefined,
  effectiveMargin: undefined,
  requiredMargin: undefined,
  recommendedMargin: undefined,
};
